export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-ink text-bg">
      <div className="overflow-hidden border-b border-bg/10">
        <div
          className="marquee-track flex whitespace-nowrap py-6 md:py-10 text-bg/90"
          aria-hidden
        >
          {Array.from({ length: 2 }).map((_, k) => (
            <span key={k} className="flex items-center gap-10">
              {['Pod Bristol', 'Domino House', 'Sanctuary', 'Glass Sculptures', 'Available 2025'].map((t, i) => (
                <span key={i} className="flex items-center gap-10">
                  <span className="font-display text-5xl md:text-7xl tracking-tight">{t}</span>
                  <span className="text-crimson text-3xl">✦</span>
                </span>
              ))}
            </span>
          ))}
        </div>
      </div>

      <div className="mx-auto max-w-[1440px] px-6 md:px-10 py-14 md:py-20 grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-5">
          <div className="font-display text-3xl md:text-4xl">Joanna Bedevian</div>
          <p className="text-bg/70 mt-3 max-w-sm leading-relaxed">
            Interior design and glass studio in Bristol. Building rooms that age with grace.
          </p>
        </div>

        <div className="col-span-6 md:col-span-3">
          <div className="kicker !text-bg/60">Navigate</div>
          <ul className="mt-4 space-y-2 text-bg/90">
            <li><a href="#pod-bristol" className="hover-underline">Pod Bristol</a></li>
            <li><a href="#about" className="hover-underline">About</a></li>
            <li><a href="#projects" className="hover-underline">Projects</a></li>
            <li><a href="#contact" className="hover-underline">Contact</a></li>
          </ul>
        </div>

        <div className="col-span-6 md:col-span-3 md:col-start-10">
          <div className="kicker !text-bg/60">Studio</div>
          <ul className="mt-4 space-y-2 text-bg/90">
            <li>Bristol, UK</li>
            <li><a className="hover-underline" href="mailto:hello@bedeviandesigns.com">hello@bedeviandesigns.com</a></li>
            <li><a className="hover-underline" target="_blank" rel="noopener noreferrer" href="https://www.bedeviandesigns.com">Original folio →</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-bg/10">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between text-xs tracking-[0.2em] uppercase text-bg/60 gap-3">
          <span>© {new Date().getFullYear()} Bedevian Designs · All rights reserved</span>
          <span>Built with care · Bristol</span>
        </div>
      </div>
    </footer>
  );
}
